<button
    [type]="type"
    mat-raised-button
    color="accent"
    [disabled]="disabled || busy"
>
    <mat-icon *ngIf="busy">
        <mat-spinner diameter="20"></mat-spinner>
    </mat-icon>
    {{ text }}
</button>
